/* eslint-disable react-hooks/rules-of-hooks */
import { toast } from "@tuv-indo/toast";
import axios, { AxiosError, AxiosResponse } from "axios";

import { AuthAtomType } from "../auth/auth.atom";

const advanceSchedulingApi = process.env.REACT_APP_ADVANCE_SCHEDULING_API;

interface ApiResponse<T = unknown> {
    message: string;
    data: T;
    code: string;
    error?: {
        code: string;
        message: string;
    };
}

interface ExchangeResponse {
    redirectURL: string;
    accessToken: string;
    refreshToken: string;
}

interface ExchangeTokenProps {
    auth: AuthAtomType | null;
}

export const useExchangeToken =
    ({ auth }: ExchangeTokenProps) =>
    () => {
        axios
            .post(`${advanceSchedulingApi}/auth/exchange`, undefined, {
                headers: {
                    Authorization: auth?.access.access_token
                        ? `Bearer ${btoa(auth?.access?.access_token)}`
                        : undefined,
                    "User-ID": auth?.id ? btoa(`${auth?.id}`) : undefined,
                },
            })
            .then((res: AxiosResponse<ApiResponse<ExchangeResponse>>) => {
                if (res.data.data.redirectURL) {
                    window.open(
                        `${res.data.data?.redirectURL}?access=${JSON.stringify(
                            res.data.data
                        )}`,
                        "_blank"
                    );
                }
            })
            .catch((err: AxiosError<ApiResponse>) => {
                toast.danger(
                    err.response?.data.error?.message || "Something went wrong"
                );
            });
    };

// window.location.href =
// `${res.data?.redirectURL}?access=${res.data?.accessToken}&data=${JSON.stringify(res.data)}` as string;
